import{jsx as e,jsxs as t,Fragment as i}from"react/jsx-runtime";import n from"styled-components";import{createContext as o,useContext as a,useState as r,useEffect as l,useRef as c,useCallback as d}from"react";import{useLocation as s,useHistory as g}from"react-router-dom";import{SidePanelMemo as h}from"exo-frontend-remote-components";import{useCartSideMenu as p,useMarketplaceContext as m}from"@exo/contexts";import{gql as u,useMutation as f,useQuery as x}from"@apollo/client";import{useSessionContext as b}from"@exo/frontend-common-session-context";import w from"universal-cookie";import{useCart as v,CartContainer as A}from"@exo/frontend-features-cart-logic";import{useLinkRegister as C}from"exo-frontend-remote-hooks";import{TagManagerUtils as N,ActionType as k,UserLoggedStatus as E}from"exo-frontend-remote-utils";import{ChevronDown16 as y,Search16 as R,Close24 as I,ChevronRight16 as M,ChevronLeft24 as S,ArrowRight16 as L,Menu24 as B,ShoppingCartError24 as D,ChevronLeft16 as Q,ChevronUp16 as O}from"@carbon/icons-react";import{useOIDC as P}from"@exo/frontend-features-authentication-logic";const T=n.section`
  display: flex;
  justify-content: center;
  width: 100%;

  height: fit-content;
  min-height: 132px;
  max-height: 168px;
  background-color: #fff;

  border-bottom: 1px solid #d9dcdd;

  position: relative;
  //z-index: 101;

  button {
    outline: none;
    border: none;
  }
`,F=n.div`
  width: 100%;

  @media (min-width: 1312px) {
    width: 78rem;
  }
  @media (min-width: 1056px) and (max-width: 1311px) {
    width: 64rem;
  }
  @media (max-width: 1055px) {
    padding: 0 1rem;
  }
`,H=o(void 0),G=()=>{const e=a(H);if(!e)throw new Error("useModalContext should be used inside");return e},z=n.div`
  position: fixed;
  background-color: #00000064;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: 0;
  z-index: 20;
  pointer-events: none;
  transition: 200ms ease-in-out opacity;

  &.show {
    opacity: 1;
    pointer-events: all;
  }

  // This is a workaround to make the dark area not cover the header
  mask-image: linear-gradient(#fff, #fff), linear-gradient(#000, #000);
  mask-size:
    100% 100%,
    100% ${e=>e.$maskHeight||0}px;
  mask-position:
    0 0,
    0px 0px;
  mask-repeat: no-repeat, no-repeat;
  mask-composite: exclude;
`,Y=132,j=149,J=({className:t})=>{const{maskHeight:i}=(()=>{const{responsive:e}=G(),[t,i]=r(0);return l((()=>{e.isSmall?i(j):i(Y)}),[e]),l((()=>{const t=()=>{const t=Math.max((e.isSmall?j:Y)-window.scrollY,0);i(t)};return window.addEventListener("scroll",t),()=>{window.removeEventListener("scroll",t)}}),[e]),{maskHeight:t}})();return e(z,{className:`${t}`,$maskHeight:i})},Z=({children:i})=>{const[n,o]=r(),[a,c]=r(!1),[d,g]=r(window.innerWidth),[m,u]=r({isLarge:!0,isMedium:!1,isSmall:!1}),{cartSideMenu:f,setCartSideMenu:x}=p();function b(){x({openSideMenu:!1,openAppMenu:!1})}function w(){c(!1)}function v(){w(),x({openSideMenu:!0,openAppMenu:!1})}l((()=>{const e=()=>{d!==window.innerWidth&&(g(window.innerWidth),w())};return window.addEventListener("resize",e),()=>{window.removeEventListener("resize",e)}}),[d]),l((()=>{u(d>=1312?{isLarge:!0,isMedium:!1,isSmall:!1}:d>=1056&&d<1312?{isLarge:!1,isMedium:!0,isSmall:!1}:{isLarge:!1,isMedium:!1,isSmall:!0})}),[d]);const A=s();return l((()=>{if(A.pathname)return w()}),[A]),l((()=>{if(window.location.href.includes("?openCart=true"))return v()}),[window.location.href]),t(H.Provider,{value:{responsive:m,isOpen:a,activeModalID:n,sidebar:{isOpen:null==f?void 0:f.openSideMenu,onClose:b,onOpen:v},onOpen:function(){b(),c(!0)},onClose:w,onIDChange:function(e){o(e)}},children:[i,e(J,{className:a?"show":""}),e(h,{position:"right",elevation:9999,isCloseOnOverlayClick:!0,onClose:b,isOpen:null==f?void 0:f.openSideMenu})]})},U=u`
  mutation AgroLogout($client: String, $refreshToken: String) {
    agroLogout(client: $client, refresh_token: $refreshToken) {
      logout
    }
  }
`;const q=()=>{const e=g(),t=b(),[i,{loading:n,error:o,data:a}]=f(U);return{loading:n,error:o,data:a,performLogout:function(){i().then((i=>{var n;(null===(n=i.data)||void 0===n?void 0:n.agroLogout.logout)&&(!function(){const e=new w;e.remove("permissions",{path:"/"}),e.remove("_ga",{path:"/"}),e.remove("psid",{path:"/"}),e.remove("logged",{path:"/"}),e.remove("registerRedirect",{path:"/"})}(),t.replace({roles:[]}),e.push("/"),e.go(0))}))}}},W=u`
  query GetHeader {
    getHeader {
      logo
      logoDescription
      loginSection {
        id
        label
        icon
        loginItems {
          id
          label
          link
        }
      }
      loggedSection {
        id
        section_one {
          id
          title
          link_button
          page_type
          image_url
          enabled
          link_app
          webview
          isExternalRedirect
        }
        section_two {
          id
          title
          link_button
          page_type
          image_url
          enabled
          link_app
          webview
          isExternalRedirect
        }
        section_three {
          id
          title
          link_button
          page_type
          image_url
          enabled
          link_app
          webview
          isExternalRedirect
        }
      }
      cart {
        id
        label
        icon
      }
      downloadApp {
        id
        qrCodeImage
        title
        description
        label
        icon
        downloadAppButtons {
          id
          buttonName
          buttonIcon
          buttonLink
        }
      }
      searchCategory {
        id
        label
        redirect
        redirectMobile
      }
      highlightProducts {
        id
        image
        title
        redirect
        redirectMobile
      }
      menuLinks {
        id
        isWebview
        enabled
        name
        redirect
        icon
        redirectMobile
        appOnly
      }
      slider {
        enabledPaths
        enabledMobilePaths
        sliderItems {
          id
          title
          icon
          onFire
          isFixed
          isWebview
          redirect
          redirectMobile
        }
      }
      categoryMarketplace {
        id
        label
        icon
        enabled
        name
        url_key
        url_path
        path
        children {
          id
          bannerImage
          redirect
          icon
          name
          url_key
          url_path
          path
          children {
            id
            bannerImage
            redirect
            icon
            name
            url_key
            url_path
            path
          }
        }
      }
      deliveryRegion {
        label
        description
        buttonLabel
        buttonPlaceHolder
      }
    }
  }
`,X=u`
  query GetNotificationByCpf {
    getNotificationByCpf {
      id
      read
    }
  }
`,K=u`
  query GetMunicipio($uf: String) {
    getMunicipio(uf: $uf)
  }
`,V=o(void 0),_=()=>{const e=a(V);if(!e)throw new Error("useHeaderServiceContext should be used inside a HeaderService provider");return e},$=[{name:"Acre",sigla:"AC"},{name:"Alagoas",sigla:"AL"},{name:"Amapá",sigla:"AP"},{name:"Amazonas",sigla:"AM"},{name:"Bahia",sigla:"BA"},{name:"Ceará",sigla:"CE"},{name:"Distrito Federal",sigla:"DF"},{name:"Espírito Santo",sigla:"ES"},{name:"Goiás",sigla:"GO"},{name:"Maranhão",sigla:"MA"},{name:"Mato Grosso",sigla:"MT"},{name:"Mato Grosso do Sul",sigla:"MS"},{name:"Minas Gerais",sigla:"MG"},{name:"Pará",sigla:"PA"},{name:"Paraíba",sigla:"PB"},{name:"Paraná",sigla:"PR"},{name:"Pernambuco",sigla:"PE"},{name:"Piauí",sigla:"PI"},{name:"Rio de Janeiro",sigla:"RJ"},{name:"Rio Grande do Norte",sigla:"RN"},{name:"Rio Grande do Sul",sigla:"RS"},{name:"Rondônia",sigla:"RO"},{name:"Roraima",sigla:"RR"},{name:"Santa Catarina",sigla:"SC"},{name:"São Paulo",sigla:"SP"},{name:"Sergipe",sigla:"SE"},{name:"Tocantins",sigla:"TO"}];function ee(){const e=(new w).get("marketplace");return e&&(null==e?void 0:e.city)&&(null==e?void 0:e.uf)?`${e.city}, ${e.uf}`:""}function te(e,t,i,n){return new(i||(i=Promise))((function(o,a){function r(e){try{c(n.next(e))}catch(e){a(e)}}function l(e){try{c(n.throw(e))}catch(e){a(e)}}function c(e){var t;e.done?o(e.value):(t=e.value,t instanceof i?t:new i((function(e){e(t)}))).then(r,l)}c((n=n.apply(e,t||[])).next())}))}var ie;function ne(e){(e&&e.length<1||!e)&&console.error("Invalid tagging object.");const t=b();function i(e){return e?e.normalize("NFD").replace(/[\u0300-\u036f]/g,"").replaceAll(" ","-").toLowerCase():""}return{callTagManager:function(n,o,a,r){return te(this,void 0,void 0,(function*(){if(e){const l=e.find((e=>e.tagId===n));if(l)return"INTERACT"===l.tagParams.GTAGFunctionType?function(e,n,o,a){N.interact(k.Click,e.local_acao||"",i(o||e.nome_elemento),i(a||e.fluxo),E.LoggedIn,e.tela||"",null,{userId:N.getUserId(t)},null,n?[{fieldName:"title",fieldValue:n}]:void 0)}(l.tagParams,l.tagParams.title,o,a):function(e,n,o){N.pageview(k.PageView,e.fluxo||"",N.getUserStatus(t),i(o||e.tela),e.local_acao||"web",null,{userId:N.getUserId(t)},void 0,null,n?[{fieldName:"title",fieldValue:n}]:void 0)}(l.tagParams,l.tagParams.title,r)}return console.error("There is no tagging object created for that type of product.")}))}}}"function"==typeof SuppressedError&&SuppressedError,function(e){e.eventData="Event_Data",e.screenData="Screen_Data"}(ie||(ie={}));const oe=[{tagId:"headerSimpleClick",tagParams:{GTAGFunctionType:"INTERACT",event:ie.eventData,tela:"e-agro/header",local_acao:"web",fluxo:"header",nome_elemento:"{{override}}"}},{tagId:"headerHighlightClick",tagParams:{GTAGFunctionType:"INTERACT",event:ie.eventData,tela:"e-agro/header",local_acao:"web",fluxo:"modal-resultado-busca",nome_elemento:"{{override}}"}},{tagId:"headerSearchClick",tagParams:{GTAGFunctionType:"INTERACT",event:ie.eventData,fluxo:"busca",tela:"e-agro/header",local_acao:"web",nome_elemento:"{{override}}"}},{tagId:"headerSetRegionClick",tagParams:{GTAGFunctionType:"INTERACT",event:ie.eventData,fluxo:"definir-regiao",tela:"e-agro/header",local_acao:"web",nome_elemento:"{{override}}"}},{tagId:"headerDownloadAppClick",tagParams:{GTAGFunctionType:"INTERACT",event:ie.eventData,fluxo:"baixe-o-app",tela:"e-agro/header",local_acao:"web",nome_elemento:"{{override}}"}},{tagId:"headerLoginClick",tagParams:{GTAGFunctionType:"INTERACT",event:ie.eventData,fluxo:"login",tela:"e-agro/header",local_acao:"web",nome_elemento:"{{override}}"}},{tagId:"headerCartClick",tagParams:{GTAGFunctionType:"INTERACT",event:ie.eventData,fluxo:"carrinho",tela:"e-agro/header",local_acao:"web",nome_elemento:"{{override}}"}}],ae=({children:t})=>{var i;const{setSelectedRegion:n}=m(),[o,a]=r(ee()),[c,d]=r([]),[h,p]=r(!1),[u,f]=r(!1),[w,N]=r(""),k=g(),{callTagManager:E}=ne(oe),y=b();l((()=>{f(Boolean(y.token&&"GUEST"!==y.type))}),[y]);const{data:R,loading:I}=(()=>{const{loading:e,error:t,data:i}=x(W);return{loading:e,error:t,data:i}})(),{data:M}=(()=>{const{loading:e,error:t,data:i}=x(X,{fetchPolicy:"no-cache"});return{loading:e,error:t,data:i}})(),{data:S,loading:L}=v({cartId:y.cartId||""},A.fragment),{data:B,loading:D}=(()=>{const{loading:e,error:t,data:i}=x(K,{variables:{uf:null},fetchPolicy:"cache-first"});return{loading:e,error:t,data:i}})(),{performLogout:Q}=q(),{redirectLogin:O,redirectRegister:P}=C();l((()=>{!D&&B&&d(function(e){return e?JSON.parse(e):[]}(B.getMunicipio))}),[B,D]);const T=s();function F(e){const t=e.split("/");return t.length>1?t[1]:t[0]}return l((()=>{if(!I&&R){const e=F(T.pathname),t=R.getHeader.slider.enabledPaths.some((t=>F(t)===e));p(t)}}),[T,R,I]),e(V.Provider,{value:{data:R,loading:I,isLogged:u,searchInput:{value:w,onChange:e=>N(e)},sessionContext:y,canShowOnfireMenu:h,navigate:e=>k.push(e||"/"),signOut:Q,notificationAmount:(null==M?void 0:M.getNotificationByCpf.filter((e=>!e.read)).length)||0,cart:{cartData:null==S?void 0:S.me.carts[0],cartAmount:(null==S?void 0:S.me.carts)&&S.me.carts.length>0&&(null===(i=null==S?void 0:S.me.carts[0].lineItems)||void 0===i?void 0:i.reduce(((e,t)=>e+t.quantity),0))||0,cartLoading:L},region:{regionData:c,regionLoading:D,selectedRegion:ee(),regionInput:o,setRegionInput:e=>a(e),setMarketplaceCookie:e=>{var t,i,o,a,r,l;return n({miraklRegion:[(null===(t=e.region_rgi_id)||void 0===t?void 0:t.toString())||"",(null===(i=e.region_rg_int_id)||void 0===i?void 0:i.toString())||"",(null===(o=e.region_uf_id)||void 0===o?void 0:o.toString())||"",(null===(a=e.region_rb_id)||void 0===a?void 0:a.toString())||"",(null===(r=e.region_pais_id)||void 0===r?void 0:r.toString())||""],state:(null===(l=$.find((t=>t.sigla===e.region_uf_code.split("_")[1])))||void 0===l?void 0:l.name)||"",uf:e.region_uf_code.split("_")[1]||"",city:e.nome_municipio,regionList:[e.region_rb_code||"",e.region_rg_int_code||"",e.region_rgi_code||"",e.region_uf_code||"",e.region_pais_code||""]})}},OIDCredirection:{onRedirectLogin:e=>O(e),onRedirectRegistration:e=>P(e)},callTagManager:E},children:t})},re=n.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1.5rem 0;
  gap: 2rem;
`,le=n.div`
  display: flex;
  flex-direction: column;
  position: relative;

  justify-content: space-between;

  width: 100%;
  padding: 1rem 0;
  gap: 1rem;
`,ce=n.img`
  width: 128px;
  height: 28px;
  object-fit: contain;
  cursor: pointer;
`,de=n.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 260px;

  .primary {
    cursor: pointer;
    border: none;
    outline: none;
    border-radius: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem 1.5rem;
    background-color: #0c881e;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    transition: 200ms all;
    margin-top: 0.5rem;

    &:not(:disabled):hover {
      filter: brightness(1.1);
    }

    &:disabled {
      background-color: #a7a8ac;
      color: #6d6e71;
      cursor: not-allowed;
    }
  }

  h1 {
    font-weight: 600;
    font-size: 1rem;
  }
  h2 {
    font-weight: 400;
    font-size: 14px;
    color: #6d6e71;
  }

  .input-container {
    display: flex;
    flex-direction: column;
    position: relative;

    margin-top: 1rem;
    gap: 1rem;

    .region-input {
      width: 100%;
      padding: 0.5rem 1rem;
      outline: none;
      border: 1px solid #d9dcdd;
      border-radius: 0.5rem;
      font-weight: 400;
      font-size: 14px;
      color: #000;
      transition: 200ms all;

      &:focus,
      &:focus-visible,
      &:focus-within,
      &:hover {
        border: 1px solid #0670bf;
      }
    }
  }
`,se=n.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  // Hidden by default
  opacity: 0;
  pointer-events: none;

  left: 0;
  top: 2.5rem;
  z-index: 1;

  width: 100%;
  max-height: 200px;
  overflow-y: auto;

  border: 1px solid #d9dcdd;
  background-color: #fff;
  border-radius: 0.225rem;

  transition: 150ms all;

  &.show {
    opacity: 1;
    pointer-events: all;
  }

  .region-button-modal {
    padding: 1rem;
    background-color: #fff;
    color: #000;
    transition: 150ms all;
    text-align: left;
    cursor: pointer;

    :not(:last-child) {
      border-bottom: 1px solid #d9dcdd;
    }

    &:hover {
      filter: brightness(0.96);
    }
  }
`;function ge(e,t){return`${e}, ${t.split("_")[1]}`}const he=()=>{const{onClose:i}=G(),{data:n,region:o,callTagManager:a}=_(),[c,d]=r(!1),[s,g]=r(!1),[h,p]=r(null);l((()=>{o.selectedRegion&&o.setRegionInput(o.selectedRegion)}),[o.selectedRegion]);const m=o.regionData.filter((e=>ge(e.nome_municipio.toLowerCase(),e.region_uf_code.toLowerCase()).includes(o.regionInput.toLowerCase())));return t(de,{children:[e("h1",{children:null==n?void 0:n.getHeader.deliveryRegion.label}),e("h2",{children:null==n?void 0:n.getHeader.deliveryRegion.description}),t("div",{className:"input-container",children:[e("input",{type:"text",className:"region-input",placeholder:null==n?void 0:n.getHeader.deliveryRegion.buttonPlaceHolder,onChange:e=>(o.setRegionInput(e.target.value),e.target.value.length>0?(d(!1),m.length>0&&g(!0)):g(!1)),value:o.regionInput}),m.length>0&&e(se,{className:s?"show":"",children:m.map((t=>e("button",{className:"region-button-modal",onClick:()=>function(e){d(!0),p(e),g(!1),o.setRegionInput(ge(e.nome_municipio,e.region_uf_code))}(t),children:ge(t.nome_municipio,t.region_uf_code)},t.id)))})]}),e("button",{className:"primary",disabled:!c,onClick:()=>{a("headerSetRegionClick",o.regionInput),c&&h&&(i(),o.setRegionInput(o.regionInput),o.setMarketplaceCookie(h))},children:null==n?void 0:n.getHeader.deliveryRegion.buttonLabel})]})},pe=n.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  .qr-code-img {
    min-height: 90px;
    min-width: 90px;
    width: 90px;
    height: 90px;
  }

  .title {
    font-weight: bold;
    font-size: 1rem;
  }

  .subtitle {
    font-weight: 400;
    font-size: 12px;
    color: #6d6e71;
  }

  .items-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;
  }

  .button-container {
    display: grid;
    width: 100%;
    gap: 0.5rem;
    grid-template-columns: 1fr 1fr;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    background-color: #000;
    border-radius: 100px;
    color: #fff;
    padding: 0.5rem 1rem;
    cursor: pointer;
    transition: 200ms all;

    font-weight: 500;
    font-size: 14px;

    &:hover {
      filter: brightness(0.8);
    }
  }
`,me=n.img`
  width: 24px;
  height: 24px;
  min-height: 24px;
  min-width: 24px;
  object-fit: contain;
`,ue=()=>{const{responsive:i}=G(),{data:n,callTagManager:o}=_();return t(pe,{children:[(i.isLarge||i.isMedium)&&e("img",{className:"qr-code-img",src:null==n?void 0:n.getHeader.downloadApp.qrCodeImage,loading:"lazy",alt:"QR Code"}),t("div",{className:"items-container",children:[t("div",{children:[e("p",{className:"title",children:null==n?void 0:n.getHeader.downloadApp.label}),(i.isLarge||i.isMedium)&&e("p",{className:"subtitle",children:null==n?void 0:n.getHeader.downloadApp.description})]}),e("div",{className:"button-container",children:null==n?void 0:n.getHeader.downloadApp.downloadAppButtons.map((i=>t("a",{href:i.buttonLink,target:"_blank",rel:"noreferrer",onClick:()=>o("headerDownloadAppClick",i.buttonName),children:[e(me,{src:i.buttonIcon,alt:i.buttonName,loading:"lazy"}),i.buttonName]},i.id)))})]})]})},fe=t=>e("MOBILE_REGION_MODAL"===t?he:"MOBILE_DOWNLOAD_MODAL"===t?ue:i,{}),xe=e=>"MOBILE_REGION_MODAL"===e?{tipLocation:"TOP_LEFT",position:{top:140}}:"MOBILE_DOWNLOAD_MODAL"===e?{tipLocation:"TOP_RIGHT",position:{right:39,top:56}}:{tipLocation:"NONE"},be=n.div`
  position: relative;
  display: inline-flex;
  border: 1px solid #d9dcdd;
  border-radius: 100px;
  padding: 5px 5px 5px 1rem;
  gap: 12px;
  transition: 100ms all;

  width: 100%;
  height: 36px;

  &.focused {
    border: 1px solid #0670bf;
    outline: 2px solid #0670bf;
  }

  svg {
    transition: 150ms all;
  }
  .up {
    transform: rotate(180deg);
  }

  .region-button {
    display: inline-flex;
    gap: 0.5rem;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    text-align: left;

    min-width: fit-content;

    color: #0c881e;

    transition: 200ms all;
    border-right: 1px solid #d9dcdd;
    padding-right: 0.5rem;

    cursor: pointer;

    &:hover {
      filter: brightness(1.2);
    }
  }

  .submit-search {
    display: inline-flex;
    border-radius: 100px;
    padding: 0.225rem 1rem;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: #0c881e;
    transition: 200ms all;
    cursor: pointer;

    &:hover {
      filter: brightness(1.2);
    }
  }

  .search-bar-input {
    outline: none;
    border: none;
    width: 100%;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;

    &::placeholder {
      color: #d9dcdd;
    }
  }

  form {
    display: flex;
    width: 100%;
  }
`,we=n.div`
  position: absolute;
  background-color: #fff;
  padding: 1rem;
  border-radius: 0.5rem;
  opacity: 0;
  pointer-events: none;
  //overflow: hidden;

  height: fit-content;
  width: fit-content;

  display: flex;
  align-items: center;

  ${({$top:e})=>void 0!==e?`top: ${e}px;`:""};
  ${({$bottom:e})=>void 0!==e?`bottom: ${e}px;`:""};
  ${({$left:e})=>void 0!==e?`left: ${e}px;`:""};
  ${({$right:e})=>void 0!==e?`right: ${e}px;`:""};

  box-shadow: 0 0px 7px 3px #0000001f;

  transition: 200ms all;

  &.show {
    opacity: 1;
    pointer-events: all;
    z-index: 110;
  }

  &::before {
    content: "";
    position: absolute;
    background-color: #ffffff;
    width: 12px;
    height: 12px;
    transform: rotate(45deg);

    ${({$tipLocation:e})=>{switch(e){case"TOP_LEFT":return"\n            top: 1px;\n            left: 14px;\n            transform: translateY(-50%) rotate(45deg);\n          ";case"CENTER":return"\n            top: -6px;\n            left: 50%;\n            transform: translateX(-50%) rotate(45deg);\n          ";case"TOP_RIGHT":return"\n            top: 1px;\n            right: 14px;\n            transform: translateY(-50%) rotate(45deg);\n          ";default:return"\n            display: none;\n          "}}}
  }
`,ve=({id:t,className:i,tipLocation:n="NONE",children:o,isOpen:a=!1,position:d,onClose:s})=>{const{activeModalID:g}=G(),h=c(null),[p,m]=r(n);return l((()=>{m(n)}),[n]),l((()=>{const e=e=>{h.current&&!h.current.contains(e.target)&&s()};return a&&document.addEventListener("mousedown",e),()=>{document.removeEventListener("mousedown",e)}}),[a,s]),e(we,{className:`${i}${a&&g===t?" show":""}`,ref:h,$top:null==d?void 0:d.top,$bottom:null==d?void 0:d.bottom,$left:null==d?void 0:d.left,$right:null==d?void 0:d.right,$tipLocation:p,onMouseDown:e=>e.stopPropagation(),children:o})},Ae=n.img`
  width: ${e=>e.$size+"px"};
  height: ${e=>e.$size+"px"};
  object-fit: contain;

  filter: ${e=>"GREEN"===e.$color?"brightness(0) saturate(100%) invert(35%) sepia(76%) saturate(820%) hue-rotate(85deg) brightness(91%) contrast(95%)":"brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(329deg) brightness(106%) contrast(114%)"};
`,Ce=n.img`
  width: 21px;
  height: 15px;
  min-width: 21px;
  min-height: 15px;
  object-fit: contain;
`;var Ne="data:image/png;base64,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";const ke=({size:t=18,color:i="GREEN",src:n,alt:o})=>e(Ae,{src:n,$color:i,$size:t,loading:"lazy",alt:o}),Ee=()=>e(Ce,{src:Ne,loading:"lazy",alt:"Bandeira do Brasil"}),ye=n.div`
  display: flex;
  gap: 0.5rem;
  height: fit-content;
  width: fit-content;

  h1 {
    font-weight: 600;
    font-size: 1rem;
  }

  .first-column {
    display: flex;
    flex-direction: column;
    width: fit-content;
    height: 100%;

    .see-more-button {
      font-weight: 600;
      font-size: 1rem;
      outline: none;
      text-align: left;
      transition: 200ms all;
      cursor: pointer;

      &:hover {
        color: #0c881e;
      }
    }

    .button-container {
      display: flex;
      flex-direction: column;
      height: 100%;

      justify-content: space-between;
      gap: 12px;
      margin-top: 1rem;
      text-wrap-mode: nowrap;
    }

    .category-button {
      cursor: pointer;
      outline: none;
      text-align: left;
      color: #6d6e71;
      font-weight: 400;
      font-size: 14px;
      transition: 200ms all;

      &:hover {
        text-decoration: underline;
        color: #0c881e;
      }
    }
  }

  .second-column {
    width: fit-content;
    height: fit-content;

    .highlight-container {
      gap: 1rem;
      display: grid;
      justify-content: space-between;
      margin-top: 1rem;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr;
    }

    .highlight-button {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      transition: 200ms all;
      width: 104px;
      cursor: pointer;

      img {
        width: 104px;
        height: 104px;
        border-radius: 0.5rem;
      }

      .product-title {
        font-weight: 400;
        font-size: 12px;
        color: #6d6e71;
        text-align: center;
      }

      &:hover {
        filter: brightness(0.8);
        transform: scale(1.02);
      }
    }
  }
`,Re=n.span`
  display: block;
  width: 1px;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  background-color: #d9dcdd;
`,Ie=()=>{const{data:i,navigate:n,callTagManager:o}=_();return t(ye,{children:[t("div",{className:"first-column",children:[e("button",{className:"see-more-button",onClick:()=>{o("headerHighlightClick","ver-mais"),n("/loja")},children:"Ver mais"}),e("div",{className:"button-container",children:null==i?void 0:i.getHeader.searchCategory.map((t=>e("button",{className:"category-button",onClick:()=>{o("headerHighlightClick",t.label),n(t.redirect||"/")},children:t.label},t.id)))})]}),e(Re,{}),t("div",{className:"second-column",children:[e("h1",{children:"Produtos em destaque"}),e("div",{className:"highlight-container",children:null==i?void 0:i.getHeader.highlightProducts.map((i=>t("button",{className:"highlight-button",onClick:()=>{o("headerHighlightClick",i.title),n(i.redirect||"/")},children:[e("img",{src:i.image,alt:i.title,loading:"lazy"}),e("span",{className:"product-title",children:i.title})]},i.id)))})]})]})},Me=t=>e(t?"REGION"===t?he:"HIGHLIGHTS"===t?Ie:i:i,{}),Se=()=>{const{isOpen:i,activeModalID:n,onClose:o,position:a,tipLocation:l,onFocusInput:d,containerRef:s,onClickRegion:g}=(()=>{const{isOpen:e,onOpen:t,onClose:i,onIDChange:n,activeModalID:o}=G(),[a,l]=r("CENTER"),d=c(null),[s,g]=r({top:0,left:0});return{isOpen:e,onClose:i,position:s,tipLocation:a,containerRef:d,onFocusInput:()=>{if(d.current){n("HIGHLIGHTS"),l("NONE");const e=d.current.getBoundingClientRect();g({top:e.height+8,left:0}),t()}},onClickRegion:e=>{if(d.current){n("REGION"),l("CENTER");const i=d.current.getBoundingClientRect(),o=e.currentTarget.getBoundingClientRect();g({top:Math.ceil(o.height)+12,left:Math.ceil(o.x)-Math.ceil(i.x)+0}),t()}},activeModalID:o}})(),{region:h,searchInput:p,navigate:m,callTagManager:u}=_(),[f,x]=r(!1),[b,w]=r();return t(be,{className:f?"focused":"",ref:s,children:[t("button",{className:"region-button",onClick:e=>{g(e),w("REGION")},children:[e(Ee,{}),h.selectedRegion?h.selectedRegion:"Região de entrega",e(y,{color:"#0c881e",className:i&&"REGION"===n?"up":""})]}),t("form",{children:[e("input",{type:"text",className:"search-bar-input",value:p.value,placeholder:"Encontre na loja E-agro",onChange:e=>p.onChange(e.target.value),onFocus:()=>{x(!0),d(),w("HIGHLIGHTS")},onBlur:()=>x(!1)}),e("button",{className:"submit-search",onClick:e=>{u("headerSearchClick",p.value),((e,t,i)=>{e.preventDefault(),i&&t(`/loja/resultado-busca/f/?busca=${i}`)})(e,m,p.value)},children:e(R,{})})]}),e(ve,{id:b,isOpen:i,onClose:o,position:a,tipLocation:l,children:Me(b)})]})},Le=n.div`
  display: inline-flex;
  gap: 1.5rem;

  align-items: baseline;

  width: 100%;
  height: fit-content;

  .main-menu-button {
    position: relative;

    .red-dot {
      position: absolute;
      right: -1px;
      top: 2px;

      width: 10px;
      height: 10px;
      min-width: 10px;
      min-height: 10px;

      border-radius: 100%;
      background-color: #e1173e;
      border: 2px solid #fff;
    }
  }

  .button-section {
    display: inline-flex;
    gap: 1.5rem;
    margin-left: auto;

    button {
      position: relative;
    }

    .cart-amount {
      position: absolute;
      font-size: 12px;
      font-weight: 600;
      line-height: 120%;
      color: #e1173e;

      left: 50%;
      transform: translateX(-50%);
      background-color: #fff;
      bottom: 16px;
    }

    .icon {
      width: 24px;
      height: 24px;

      min-height: 24px;
      min-width: 24px;

      filter: brightness(0) saturate(100%) invert(34%) sepia(44%)
        saturate(5220%) hue-rotate(119deg) brightness(85%) contrast(91%);
    }
  }
`,Be=n.img`
  width: 110px;
  height: 24px;
  object-fit: contain;
  cursor: pointer;
`,De=n.section`
  position: fixed;
  z-index: 200;

  width: 100%;
  height: 100%;

  transition: 150ms all;

  opacity: 0;
  pointer-events: none;

  background-color: #fff;

  left: 0;
  top: 0;

  overflow-y: auto;

  &.show {
    opacity: 1;
    pointer-events: all;
  }
`,Qe=n.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  justify-content: space-between;
`,Oe=n.div`
  display: flex;
  flex-direction: column;

  padding: 1.5rem 1rem;
  gap: 1.5rem;
  width: 100%;
`,Pe=n.div`
  position: relative;

  display: flex;
  flex-direction: column;

  width: 100%;
  height: fit-content;

  padding: 1rem 1.5rem;
  gap: 1rem;

  background-color: #f7f7f7;

  .close-button {
    position: absolute;
    right: 1rem;
    width: fit-content;
    height: fit-content;
  }

  .avatar-wrapper {
    display: inline-flex;
    gap: 1rem;

    .avatar-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 64px;
      min-width: 64px;
      min-height: 64px;
      border-radius: 100%;
      background-color: #f0f0f0;

      .avatar {
        width: 32px;
        height: 32px;
        min-width: 32px;
        min-height: 32px;
        filter: brightness(0) saturate(100%) invert(60%) sepia(98%)
          saturate(11%) hue-rotate(191deg) brightness(94%) contrast(84%);
      }
    }

    .text-content {
      display: flex;
      flex-direction: column;
      gap: 0.225rem;

      .greetings {
        font-size: 1rem;
        font-weight: 600;
        line-height: 140%;
        color: #000;
      }

      .title {
        font-size: 1rem;
        line-height: 140%;
        color: #000;
      }

      .subtitle {
        font-size: 14px;
        font-weight: 400;
        line-height: 140%;
        color: #6d6e71;
      }

      .link-button {
        text-align: left;
        margin-top: 0.5rem;
        color: #0c881e;
        font-size: 14px;
        font-weight: 600;
        line-height: 100%;
      }
    }
  }

  .button-area {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;

    .primary {
      width: 100%;
      padding: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #0c881e;
      color: #fff;
      border-radius: 100px;

      font-size: 14px;
      font-weight: 600;
      line-height: 100%;
    }

    .secondary {
      width: 100%;
      padding: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #0c881e;
      border: 2px solid #0c881e;
      border-radius: 100px;

      font-size: 14px;
      font-weight: 600;
      line-height: 100%;
    }
  }
`,Te=()=>{var i;const{data:n,isLogged:o,signOut:a,navigate:r,sessionContext:l,callTagManager:c}=_(),{onClose:d}=G();return t(Pe,{children:[t("div",{className:"avatar-wrapper",children:[e("span",{className:"avatar-container",children:e("img",{className:"avatar",src:null==n?void 0:n.getHeader.loginSection.icon,alt:"avatar"})}),t("span",o?{className:"text-content",children:[e("p",{className:"title",children:"Boas-vindas ao E-agro,"}),e("p",{className:"greetings",children:null===(i=l.user)||void 0===i?void 0:i.name}),e("button",{className:"link-button",onClick:()=>{c("headerSimpleClick","sair"),a()},children:"Sair"})]}:{className:"text-content",children:[e("p",{className:"greetings",children:"Boas-vindas ao E-agro"}),e("p",{className:"subtitle",children:"Tudo o que a sua fazenda precisa em um só lugar!"})]})]}),!o&&e("div",{className:"button-area",children:null==n?void 0:n.getHeader.loginSection.loginItems.map(((t,i)=>e("button",{className:0===i?"primary":"secondary",onClick:()=>{c("headerLoginClick",t.label),r(t.link)},children:t.label},t.id)))}),e("button",{className:"close-button",onClick:d,children:e(I,{})})]})},Fe=n.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  padding-bottom: 1.5rem;
  border-bottom: 1px solid #d9dcdd;
`,He=n.span`
  width: 100%;
  height: 1px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  background-color: #d9dcdd;
`,Ge=n.button`
  display: flex;
  width: 100%;
  gap: 0.5rem;
  align-items: center;

  font-size: 14px;
  font-weight: 400;
  line-height: 140%;

  &.between {
    justify-content: space-between;
  }

  .red-dot {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 2px;
    aspect-ratio: 1;

    min-width: 24px;
    min-height: 24px;

    color: #fff;
    background-color: #e1173e;
    border-radius: 100%;

    font-size: 12px;
    font-weight: 400;
    line-height: 140%;
  }

  .icon {
    width: 20px;
    height: 20px;
    min-height: 20px;
    min-width: 20px;
    filter: brightness(0) saturate(100%) invert(21%) sepia(99%) saturate(3246%)
      hue-rotate(134deg) brightness(95%) contrast(91%);
  }

  .text-icon {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    font-size: 14px;
    font-weight: 400;
    line-height: 140%;

    .icon {
      width: 20px;
      height: 20px;
      min-height: 20px;
      min-width: 20px;
      filter: brightness(0) saturate(100%) invert(21%) sepia(99%)
        saturate(3246%) hue-rotate(134deg) brightness(95%) contrast(91%);
    }
  }
`,ze=()=>{const{data:i,navigate:n,isLogged:o,notificationAmount:a,callTagManager:r}=_();return t(Fe,{children:[null==i?void 0:i.getHeader.menuLinks.map((i=>t(Ge,{onClick:()=>{r("headerSimpleClick",i.name),n(i.redirect)},children:[e("img",{className:"icon",src:i.icon,alt:"icon",loading:"lazy"}),i.name]},i.id))),o&&e(He,{}),o&&(null==i?void 0:i.getHeader.loggedSection.section_two.map((i=>t(Ge,{className:"between",onClick:()=>{r("headerSimpleClick",i.title),n(i.link_button)},children:[t("span",{className:"text-icon",children:[e("img",{className:"icon",src:i.image_url,alt:"icon",loading:"lazy"}),i.title]}),"/notification/NotificationCenterPage"===i.link_button&&a>0&&e("span",{className:"red-dot",children:a>99?"99+":a})]},i.id))))]})},Ye=n.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`,je=n.button`
  display: flex;
  width: 100%;
  gap: 0.5rem;
  align-items: center;

  font-size: 14px;
  font-weight: 400;
  line-height: 140%;

  .icon {
    width: 20px;
    height: 20px;
    min-height: 20px;
    min-width: 20px;
    filter: brightness(0) saturate(100%) invert(21%) sepia(99%) saturate(3246%)
      hue-rotate(134deg) brightness(95%) contrast(91%);
  }
`,Je=()=>{var n;const{data:o,navigate:a,isLogged:r,callTagManager:l}=_();return r?e(i,{}):e(Ye,{children:null===(n=null==o?void 0:o.getHeader.loggedSection.section_three)||void 0===n?void 0:n.map((i=>t(je,{onClick:()=>{l("headerSimpleClick",i.title),a(i.link_button)},children:[e("img",{className:"icon",src:i.image_url,alt:"icon",loading:"lazy"}),i.title]},i.id)))})},Ze=n.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`,Ue=n.button`
  display: flex;
  width: 100%;
  gap: 0.5rem;
  text-align: left;
  color: #6d6e71;
  align-items: center;

  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
`,qe=()=>{const{data:t,navigate:n,isLogged:o,callTagManager:a}=_();return o?e(Ze,{children:null==t?void 0:t.getHeader.loggedSection.section_one.map((t=>e(Ue,{onClick:()=>{a("headerSimpleClick",t.title),t.isExternalRedirect?window.open(t.link_button):n(t.link_button)},children:t.title},t.id)))}):e(i,{})},We=n.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  padding-bottom: 1.5rem;
  border-bottom: 1px solid #d9dcdd;

  h1 {
    font-weight: 600;
    font-size: 16px;
    line-height: 140%;
    text-align: left;
    margin-bottom: 0.5rem;
  }
`,Xe=n.button`
  display: flex;
  width: 100%;
  gap: 0.5rem;
  align-items: center;

  justify-content: space-between;

  .text-icon {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    font-size: 14px;
    font-weight: 400;
    line-height: 140%;

    .icon {
      width: 20px;
      height: 20px;
      min-height: 20px;
      min-width: 20px;
      filter: brightness(0) saturate(100%) invert(21%) sepia(99%)
        saturate(3246%) hue-rotate(134deg) brightness(95%) contrast(91%);
    }
  }
`,Ke=({onClickItem:i})=>{const{data:n}=_();return t(We,{children:[e("h1",{className:"title",children:"Produtos da loja"}),null==n?void 0:n.getHeader.categoryMarketplace.children.map((n=>t(Xe,{onClick:()=>i({name:n.name,children:n}),children:[t("span",{className:"text-icon",children:[e("img",{className:"icon",src:n.icon,alt:"icon",loading:"lazy"}),n.name]}),e(M,{color:"#A7A8AC"})]},n.id)))]})},Ve=n.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;

  .title-button {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;

    margin-bottom: 1rem;

    color: #000;
    font-size: 1rem;
    font-weight: 600;
    line-height: 140%;
  }

  .button-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .category-button {
      text-align: left;
      width: 100%;
      color: #000;
      font-size: 14px;
      font-weight: 400;
      line-height: 140%;
    }

    .link-button {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      text-align: left;
      width: 100%;
      color: #0c881e;
      font-size: 14px;
      font-weight: 600;
      line-height: 100%;
    }
  }

  .banner-image {
    margin-top: 2rem;
    aspect-ratio: 343 / 462;

    max-width: 343px;
    max-height: 462px;
  }
`,_e=({selectedItem:i,onGoBack:n,categoryName:o})=>{const{navigate:a,callTagManager:r}=_();return t(Ve,{children:[t("button",{className:"title-button",onClick:n,children:[e(S,{}),i.name]}),t("div",{className:"button-container",children:[i.children.map((t=>e("button",{className:"category-button",onClick:()=>{r("headerSimpleClick",t.name,o),a(`/loja/${t.url_path}`)},children:t.name},t.id))),t("button",{className:"link-button",onClick:()=>{r("headerSimpleClick","ver-tudo",o),a(`/loja/${i.url_path}`)},children:["Ver tudo",e(L,{color:"#0C881E"})]})]}),e("img",{alt:"banner",loading:"lazy",className:"banner-image",src:i.bannerImage,onClick:()=>a(i.redirect||"/")})]})},$e=()=>{const{isOpen:n,activeModalID:o}=G(),[a,l]=r(null);return e(De,{onClick:e=>e.stopPropagation(),className:n&&"RESPONSIVE_MAIN_MENU"===o?"show":"",children:t(Qe,{children:[e(Te,{}),e(Oe,{children:a?e(_e,{categoryName:a.name,selectedItem:a.children,onGoBack:()=>l(null)}):t(i,{children:[e(ze,{}),e(Ke,{onClickItem:l}),e(Je,{}),e(qe,{})]})})]})})},et=()=>{const{data:i,navigate:n,isLogged:o,cart:a,notificationAmount:r,callTagManager:l}=_(),{sidebar:c,onOpen:d,onIDChange:s}=G();return t(Le,{children:[t("button",{className:"main-menu-button",onClick:()=>{d(),s("RESPONSIVE_MAIN_MENU")},children:[e(B,{color:"#0C881E"}),r>0&&e("span",{className:"red-dot"})]}),e(Be,{src:null==i?void 0:i.getHeader.logo,alt:"logo",loading:"lazy",onClick:()=>n("/")}),t("div",{className:"button-section",children:[!window.isWebView&&e("button",{onClick:()=>{l("headerDownloadAppClick","baixe-nosso-aplicativo"),d(),s("MOBILE_DOWNLOAD_MODAL")},children:e("img",{className:"icon",src:null==i?void 0:i.getHeader.downloadApp.icon,alt:"icon",loading:"lazy"})}),t("button",{onClick:()=>{l("headerCartClick","carrinho"),c.onOpen()},children:[e("img",{className:"icon",src:null==i?void 0:i.getHeader.cart.icon,alt:"icon",loading:"lazy"}),o&&a.cartAmount>0&&e("span",{className:"cart-amount",children:a.cartAmount})]})]}),e($e,{})]})},tt=n.div`
  position: relative;

  display: inline-flex;
  gap: 1.5rem;

  .main-menu-button {
    position: relative;
    display: inline-flex;
    text-align: left;
    padding: 0.225rem;
    gap: 0.4rem;
    align-items: center;
    transition: 200ms all;
    width: fit-content;
    cursor: pointer;

    &:hover {
      color: #0c881e;
    }

    .text {
      font-size: 14px;
      white-space: nowrap;
    }

    @media (min-width: 1056px) and (max-width: 1311px) {
      .text {
        font-size: 12px;
        white-space: normal;
        min-width: fit-content;
      }
    }
  }

  .profile-icon {
    position: relative;

    .notification-signal {
      display: block;
      position: absolute;
      z-index: 1;
      width: 5px;
      height: 5px;
      right: 0;
      border-radius: 100%;
      background-color: #e1173e;
      outline: 2px solid #fff;
    }
  }

  .chart-amount-container {
    position: relative;
  }

  .chart-items-amount {
    display: block;
    position: absolute;
    background-color: #fff;

    top: -5px;
    height: fit-content;
    line-height: 1;
    border-radius: 100%;

    font-size: 14px;
    font-weight: 400;
    color: #e1173e;
    left: 50%;
    transform: translateX(-50%);
  }
`,it=e=>e?e.length>12?e.slice(0,12)+"...":e:"",nt=n.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 300px;
  gap: 0.5rem;

  &.loader-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    border-radius: 100px;
  }

  .primary {
    display: flex;
    align-items: center;
    align-self: end;
    justify-content: center;
    width: fit-content;
    padding: 0.5rem 1.5rem;
    background-color: #0c881e;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    transition: 200ms all;

    &:hover {
      filter: brightness(1.1);
    }
  }

  .no-content-title {
    font-weight: 400;
    font-size: 14px;
    color: #6d6e71;
  }

  h1 {
    width: 100%;
    font-weight: 600;
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }

  .button-container {
    overflow-y: auto;
    width: 100%;
    max-width: 380px;
    height: fit-content;
    max-height: 160px;
  }

  .footer-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-top: 1px solid #d9dcdd;
    padding: 1rem 0 0 0;
    gap: 1rem;
  }

  .footer-text-container {
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
  }

  .text {
    font-weight: 400;
    font-size: 14px;
  }

  .value-text {
    font-weight: 600;
    font-size: 1rem;
  }
`,ot=n.div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
  gap: 1rem;

  align-items: center;
  justify-content: center;

  .primary {
    display: flex;
    align-items: center;
    //align-self: end;
    justify-content: center;
    width: fit-content;
    padding: 0.5rem 1.5rem;
    background-color: #0c881e;
    width: fit-content;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    transition: 200ms all;
    border-radius: 100px;
    white-space: nowrap;
    height: 48px;
    cursor: pointer;

    &:hover {
      filter: brightness(1.1);
    }
  }

  .no-content-title {
    font-weight: 400;
    font-size: 16px;
    color: #6d6e71;
  }
`;function at(e){if(!e)return"R$ 0,00";return new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(e)}const rt=n.span`
  display: inline-flex;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem;
  background-color: #fff;
  transition: 200ms all;
  border-radius: 0.5rem !important;

  img {
    border-radius: 0.225rem;
    object-fit: contain;
    width: 48px;
    height: 48px;
  }

  .bold-title {
    text-align: left;
    width: 100%;
    font-weight: 600;
    font-size: 14px;
  }

  .text-content {
    width: 100%;
  }

  .info-container {
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
  }

  .text {
    font-weight: 400;
    font-size: 14px;
    color: #6d6e71;
  }

  .value-text {
    font-weight: 400;
    font-size: 14px;
    color: #000;
  }
`,lt=({qtd:i,value:n,title:o,productImg:a})=>t(rt,{children:[e("img",{src:a,alt:o,loading:"lazy"}),t("span",{className:"text-content",children:[e("p",{className:"bold-title",children:o}),t("span",{className:"info-container",children:[e("p",{className:"text",children:`Quantidade: ${i}`}),e("p",{className:"value-text",children:at(parseFloat(n))})]})]})]}),ct=n.span`
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  border: 4px solid transparent;
  border-top-color: #0c881e;
  animation: spinner-loader-rotate 0.8s linear infinite;

  @keyframes spinner-loader-rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`,dt=()=>e(ct,{}),st=()=>{var i,n;const{cart:o,navigate:a,callTagManager:r}=_(),{sidebar:l}=G(),c=null===(i=o.cartData)||void 0===i?void 0:i.lineItems.reduce(((e,t)=>e+parseFloat(t.linePrice.value)),0);return o.cartLoading?t(nt,{className:"loader-content",children:[e("p",{className:"no-content-title",children:"Aguarde, estamos carregando os itens do carrinho"}),e(dt,{})]}):0===o.cartAmount?t(ot,{children:[e(D,{}),e("p",{className:"no-content-title",children:"Seu carrinho está vazio"}),e("button",{className:"primary",onClick:()=>a("/loja"),children:"Confira as ofertas da sua região"})]}):t(nt,{children:[e("h1",{children:"Meu carrinho"}),e("div",{className:"button-container",children:null===(n=o.cartData)||void 0===n?void 0:n.lineItems.map((t=>e(lt,{id:t.id,qtd:t.quantity,value:t.linePrice.value,title:t.product.name,productImg:t.product.thumbnail},t.id)))}),t("div",{className:"footer-container",children:[t("div",{className:"footer-text-container",children:[e("p",{className:"text",children:"Total (valor sem frete):"}),e("p",{className:"value-text",children:at(c)})]}),e("button",{className:"primary",onClick:()=>{r("headerCartClick","ver-meu-carrinho"),l.onOpen()},children:"Ver meu carrinho"})]})]})},gt=n.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  button {
    cursor: pointer;
    border: none;
    outline: none;
    border-radius: 100px;
  }

  .primary {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    padding: 1rem 1.5rem;
    background-color: #0c881e;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    transition: 200ms all;

    &:hover {
      filter: brightness(1.1);
    }
  }

  .secondary {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    padding: 0.5rem 1.5rem;
    background-color: transparent;
    color: #0c881e;
    font-weight: 600;
    font-size: 14px;
    transition: 200ms all;

    &:hover {
      filter: brightness(1.1);
      text-decoration: underline;
    }
  }
`,ht=()=>{const{data:t,OIDCredirection:i}=_();return e(gt,{children:null==t?void 0:t.getHeader.loginSection.loginItems.map(((t,n)=>e("button",{className:0===n?"primary":"secondary",onClick:()=>0===n?i.onRedirectLogin(t.link||"/"):i.onRedirectRegistration(t.link||"/"),children:t.label},t.id)))})},pt=n.div`
  display: flex;
  flex-direction: column;
  width: 270px;
  height: fit-content;
  max-width: 340px;
  //gap: 0.5rem;

  button {
    cursor: pointer;
    border: none;
    outline: none;
  }

  .welcome-container {
    display: inline-flex;
    gap: 12px;

    .avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      min-width: 32px;
      min-height: 32px;
      background-color: #f0f0f0;
      border-radius: 100%;

      .avatar-icon {
        width: 18px;
        height: 18px;
        filter: brightness(0) saturate(100%) invert(77%) sepia(6%)
          saturate(167%) hue-rotate(191deg) brightness(89%) contrast(81%);
      }
    }

    .welcome-text {
      font-weight: 400;
      font-size: 14px;
    }

    .link-button {
      font-weight: 600;
      font-size: 14px;
      color: #0c881e;
      transition: 200ms all;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .actions-container {
    display: flex;
    flex-direction: column;
    //gap: 0.225rem;

    .action-button {
      display: inline-flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      padding: 0.5rem;
      transition: 200ms all;
      background-color: #fff;
      border-radius: 0.5rem;
      justify-content: space-between;

      &:hover {
        filter: brightness(0.95);
      }

      .icon-title {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
      }

      .notification-dot {
        display: flex;
        align-items: center;
        justify-content: center;

        padding: 2px;
        aspect-ratio: 1;

        min-width: 24px;
        min-height: 24px;

        color: #fff;
        background-color: #e1173e;
        border-radius: 100%;

        font-weight: 400;
        font-size: 11px;
      }
    }
  }

  .options-container {
    display: flex;
    flex-direction: column;
    //gap: 0.225rem;

    .option-button {
      display: inline-flex;
      text-align: left;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      padding: 0.5rem;
      transition: 200ms all;
      color: #6d6e71;
      background-color: #fff;
      border-radius: 0.5rem;
      justify-content: space-between;

      &:hover {
        filter: brightness(0.95);
      }
    }
  }
`,mt=n.span`
  display: block;
  background-color: #d9dcdd;
  width: 100%;
  height: 1px;
  margin: 1rem 0;
`,ut=n.img`
  width: 18px;
  height: 18px;
  filter: brightness(0) saturate(100%) invert(19%) sepia(91%) saturate(4536%)
    hue-rotate(139deg) brightness(98%) contrast(91%);
`,ft=()=>{var i;const{data:n,notificationAmount:o,sessionContext:a,signOut:c,navigate:d,callTagManager:s}=_(),{redirectUrl:g,passwordPageType:h}=(()=>{const[e,t]=r(""),i=P();return l((()=>{i.requestAuthorizationUrl(`${process.env.OIDC_PUBLIC_URL}/auth/callback/code`,process.env.OIDC_FLOW).then((e=>{const i=`${e.data.authRequestAuthorizationUrl}&kc_action=UPDATE_PASSWORD`.replace("https%3A%2F%2Fexo-frontend.roksagrogeraltu12815-02729b71b103a1049ce1c986ea98b5ca-i000.br-sao.containers.appdomain.cloud%2Fauth%2Fcallback%2Fcode",`${process.env.OIDC_PUBLIC_URL}/myProfile/MyProfilePage/successPass`);t(i)}))}),[]),{redirectUrl:e,passwordPageType:"ALTERAR_SENHA"}})();return t(pt,{children:[t("div",{className:"welcome-container",children:[e("span",{className:"avatar",children:e("img",{className:"avatar-icon",src:null==n?void 0:n.getHeader.loginSection.icon,alt:""})}),t("span",{children:[t("p",{className:"welcome-text",children:["Boas-vindas ao E-agro, ",e("br",{}),e("strong",{children:null===(i=a.user)||void 0===i?void 0:i.name})]}),e("button",{className:"link-button",onClick:()=>{s("headerSimpleClick","sair"),c()},children:"Sair"})]})]}),e(mt,{}),e("div",{className:"actions-container",children:null==n?void 0:n.getHeader.loggedSection.section_two.map((i=>t("button",{className:"action-button",onClick:()=>{s("headerSimpleClick",i.title),i.isExternalRedirect?window.open(i.link_button):d(i.link_button||"/")},children:[t("span",{className:"icon-title",children:[e(ut,{src:i.image_url,alt:"icon"}),i.title]}),"/notification/NotificationCenterPage"===i.link_button&&o>0&&e("span",{className:"notification-dot",children:o>99?"99+":o})]},i.title)))}),e(mt,{}),e("div",{className:"options-container",children:null==n?void 0:n.getHeader.loggedSection.section_one.map((t=>e("button",{className:"option-button",onClick:()=>{s("headerSimpleClick",t.title),t.page_type===h||t.isExternalRedirect?window.open(t.page_type===h?g:t.link_button):d(t.link_button||"/")},children:t.title},t.title)))})]})},xt=t=>e(t?"DOWNLOAD_APP"===t?ue:"SIGN_IN"===t?ht:"CART"===t?st:"PROFILE"===t?ft:i:i,{}),bt=()=>{var i;const{data:n,isLogged:o,sessionContext:a,notificationAmount:l,cart:d,callTagManager:s}=_(),{isOpen:g,onClose:h,position:p,tipLocation:m,containerRef:u,handleButtonClick:f}=(()=>{const{isOpen:e,onOpen:t,onClose:i,onIDChange:n,activeModalID:o,responsive:a}=G(),[l,d]=r("CENTER"),s=c(null),[g,h]=r({top:0,left:0});return{isOpen:e,onClose:i,position:g,tipLocation:l,containerRef:s,activeModalID:o,handleButtonClick:(e,i)=>{if(s.current){n(i);const o=s.current.getBoundingClientRect(),r=e.currentTarget.getBoundingClientRect();if("CART"===i&&(d("TOP_RIGHT"),h({top:Math.ceil(r.height)+8,right:0})),"DOWNLOAD_APP"===i){d(a.isLarge?"TOP_LEFT":"CENTER");const e=Math.ceil(r.x)-Math.ceil(o.x)-44;h({top:Math.ceil(r.height)+8,left:a.isLarge?0:2*e-66})}if("PROFILE"===i||"SIGN_IN"===i){d("CENTER");const e=Math.ceil(r.x)-Math.ceil(o.x)-44;h({top:Math.ceil(r.height)+8,left:a.isLarge?e:0})}t()}}}})(),[x,b]=r();return t(tt,{ref:u,children:[(null==n?void 0:n.getHeader.downloadApp)&&t("button",{className:"main-menu-button",onClick:e=>{s("headerSimpleClick",n.getHeader.downloadApp.label),f(e,"DOWNLOAD_APP"),b("DOWNLOAD_APP")},children:[e(ke,{src:n.getHeader.downloadApp.icon,alt:"icon"}),e("span",{className:"text",children:null==n?void 0:n.getHeader.downloadApp.label})]}),o?t("button",{className:"main-menu-button",onClick:e=>{var t;s("headerSimpleClick",`Olá, ${it(null===(t=a.user)||void 0===t?void 0:t.name)}`),f(e,"PROFILE"),b("PROFILE")},children:[t("span",{className:"profile-icon",children:[l>0&&e("span",{className:"notification-signal"}),e(ke,{src:null==n?void 0:n.getHeader.loginSection.icon,alt:"icon"})]}),e("span",{className:"text",children:`Olá, ${it(null===(i=a.user)||void 0===i?void 0:i.name)}`})]}):(null==n?void 0:n.getHeader.loginSection)&&t("button",{className:"main-menu-button",onClick:e=>{s("headerSimpleClick",n.getHeader.loginSection.label),f(e,"SIGN_IN"),b("SIGN_IN")},children:[e(ke,{src:null==n?void 0:n.getHeader.loginSection.icon,alt:"icon"}),e("span",{className:"text",children:n.getHeader.loginSection.label})]}),(null==n?void 0:n.getHeader.cart)&&t("button",{className:"main-menu-button",onClick:e=>{s("headerSimpleClick",n.getHeader.cart.label),f(e,"CART"),b("CART")},children:[t("span",{className:"chart-amount-container",children:[e(ke,{size:18,src:null==n?void 0:n.getHeader.cart.icon,alt:"icon"}),d.cartAmount>0&&e("span",{className:"chart-items-amount",children:d.cartAmount})]}),e("span",{className:"text",children:null==n?void 0:n.getHeader.cart.label})]}),e(ve,{id:x,isOpen:g,onClose:h,position:p,tipLocation:m,children:xt(x)})]})},wt=n.button`
  display: inline-flex;
  gap: 1.5rem;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: fit-content;

  padding: 5px 5px 5px 1rem;

  color: #d9dcdd;
  border: 1px solid #d9dcdd !important;
  border-radius: 100px;

  font-size: 14px;
  font-weight: 400;
  line-height: 140%;

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0c881e;
    border-radius: 100px;
    width: 50px;
    height: 26px;
  }

  &.has-value {
    color: #000;
  }
`,vt=n.section`
  position: fixed;
  z-index: 200;

  width: 100%;
  height: 100%;

  transition: 150ms all;

  opacity: 0;
  pointer-events: none;

  background-color: #fff;

  left: 0;
  top: 0;

  overflow-y: auto;

  &.show {
    opacity: 1;
    pointer-events: all;
  }
`,At=n.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  justify-content: space-between;
`,Ct=n.div`
  display: flex;
  flex-direction: column;

  padding: 1.5rem 1rem;
  gap: 1.5rem;
  width: 100%;

  .title {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    h1 {
      text-align: left;
      font-size: 18px;
      font-weight: 600;
      line-height: 140%;
    }
  }
`,Nt=n.form`
  position: relative;
  width: 100%;
  height: fit-content;

  .search-button {
    position: absolute;

    top: 50%;
    right: 5px;
    transform: translateY(-50%);

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: #0c881e;
    border-radius: 100px;

    width: 50px;
    height: 26px;
  }
`,kt=n.input`
  display: inline-flex;
  gap: 1.5rem;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 36px;

  padding: 5px 5px 5px 1rem;

  color: #000;
  border: 1px solid #d9dcdd !important;
  border-radius: 100px;

  font-size: 14px;
  font-weight: 400;
  line-height: 140%;

  &::placeholder {
    color: #d9dcdd;
  }

  &:focus,
  &:focus-visible,
  &:focus-within {
    border: 2px solid #0670bf;
  }
`,Et=n.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: fit-content;

  margin-top: 1rem;
  gap: 1rem;

  .see-more-button {
    text-align: left;
    width: fit-content;
    font-size: 16px;
    font-weight: 600;
    line-height: 140%;
  }

  .categories-selector {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 0.75rem;

    .category-button {
      width: fit-content;
      padding: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #0c881e;
      border: 1px solid #0c881e;
      border-radius: 80px;

      font-size: 12px;
      font-weight: 600;
      line-height: 100%;
    }
  }
`,yt=n.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: fit-content;

  margin-top: 1rem;
  gap: 1rem;

  .title {
    text-align: left;
    width: fit-content;
    font-size: 16px;
    font-weight: 600;
    line-height: 140%;
  }

  .highlighted-selector {
    display: inline-flex;
    gap: 0.75rem;
    overflow-y: auto;
    padding-bottom: 1rem;
  }

  .product-button {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .product-image {
      width: 104px;
      height: 104px;
      min-height: 104px;
      min-width: 104px;
      border-radius: 0.5rem;
    }

    .product-title {
      color: #6d6e71;
      font-weight: 400;
      font-size: 12px;
      line-height: 120%;
    }
  }
`,Rt=()=>{const{isOpen:i,activeModalID:n,onClose:o}=G(),{data:a,navigate:r,searchInput:l,callTagManager:c}=_();return e(vt,{onClick:e=>e.stopPropagation(),className:i&&"RESPONSIVE_SEARCH_MENU"===n?"show":"",children:e(At,{children:t(Ct,{children:[t("div",{className:"title",children:[e("h1",{children:"Busque por produtos"}),e("button",{onClick:o,children:e(I,{})})]}),t(Nt,{children:[e(kt,{placeholder:"Encontre na loja E-agro",value:l.value,onChange:e=>l.onChange(e.target.value)}),e("button",{className:"search-button",onClick:e=>{c("headerSearchClick",l.value),function(e){e.preventDefault(),l.value.length>0&&r(`/loja/resultado-busca/f/?busca=${l.value}`)}(e)},children:e(R,{color:"#fff"})})]}),t(Et,{children:[e("button",{className:"see-more-button",onClick:()=>{c("headerSimpleClick","ver-mais"),r("/loja")},children:"Ver mais"}),e("div",{className:"categories-selector",children:null==a?void 0:a.getHeader.searchCategory.map((t=>e("button",{className:"category-button",onClick:()=>{c("headerSimpleClick",t.label),r(t.redirect)},children:t.label},t.id)))})]}),t(yt,{children:[e("p",{className:"title",children:"Produtos em destaque"}),e("div",{className:"highlighted-selector",children:null==a?void 0:a.getHeader.highlightProducts.map((i=>t("button",{className:"product-button",onClick:()=>{c("headerSimpleClick",i.title),r(i.redirect)},children:[e("img",{className:"product-image",src:i.image,alt:"product",loading:"lazy"}),e("span",{className:"product-title",children:i.title})]},i.id)))})]})]})})})},It=()=>{const{onIDChange:n,onOpen:o}=G(),{searchInput:a}=_();return t(i,{children:[t(wt,{className:a.value?"has-value":"",onClick:()=>{o(),n("RESPONSIVE_SEARCH_MENU")},children:[a.value?a.value:"Encontre na loja E-agro",e("span",{className:"icon-container",children:e(R,{color:"#fff"})})]}),e(Rt,{})]})},Mt=n.button`
  display: inline-flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;

  width: fit-content;

  color: #0c881e;

  font-size: 14px;
  font-weight: 400;
  line-height: 140%;

  .flag-icon {
    width: 21px;
    height: 15px;
    min-width: 21px;
    min-height: 15px;
  }

  svg {
    transition: 150ms all;
  }

  .up {
    transform: rotate(180deg);
  }
`,St=()=>{const{isOpen:i,onOpen:n,onIDChange:o,activeModalID:a}=G(),{region:r}=_();return t(Mt,{onClick:()=>{o("MOBILE_REGION_MODAL"),n()},children:[e("img",{className:"flag-icon",src:Ne,alt:"flag",loading:"lazy"}),r.selectedRegion?r.selectedRegion:"Definir região de entrega",e(y,{color:"#0C881E",className:i&&"MOBILE_REGION_MODAL"===a?"up":""})]})},Lt=()=>{const{data:n,navigate:o}=_(),{responsive:a,isOpen:r,onClose:l,activeModalID:c}=G();return a.isSmall?t(le,{className:"header-main-wrapper-mobile",children:[e(et,{}),e(It,{}),e(St,{}),(d=c,"RESPONSIVE_MAIN_MENU"!==d&&"RESPONSIVE_SEARCH_MENU"!==d&&e(ve,Object.assign({id:c,isOpen:r,onClose:l},xe(c),{children:fe(c)})))]}):a.isLarge||a.isMedium?t(re,{className:"header-main-wrapper",children:[e(ce,{src:null==n?void 0:n.getHeader.logo,loading:"lazy",onClick:()=>o("/")}),e(Se,{}),e(bt,{})]}):e(i,{});var d},Bt=n.section`
  display: flex;
  justify-content: center;

  background-color: #f7f7f7;

  width: 100%;
  height: 0;
  border: none;

  transition: 150ms ease-in-out all;

  &.show {
    height: 64px;
    border-bottom: 1px solid #d9dcdd;
  }
`,Dt=n.div`
  width: 100%;
  overflow: hidden;

  @media (min-width: 1312px) {
    width: 78rem;
  }
  @media (min-width: 1056px) and (max-width: 1311px) {
    width: 64rem;
  }
  @media (max-width: 1055px) {
    padding: 0 1rem;
  }
`,Qt=n.div`
  display: inline-flex;
  align-items: center;
  position: relative;

  width: 100%;
  overflow: hidden;

  .control-buttons-container {
    position: absolute;

    display: flex;
    align-items: center;
    justify-content: center;

    width: fit-content;
    height: 100%;

    border: none;
    background-color: #f7f7f7;

    z-index: 1;

    .white-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      min-height: 24px;
      min-width: 24px;
      background-color: #fff;
      border-radius: 100%;
      border: none;
      cursor: pointer;

      &:not(:disabled):hover {
        filter: brightness(0.98);
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    &.left {
      left: 0;
    }

    &.right {
      right: 0;
    }
  }
`,Ot=n.div`
  display: inline-flex;
  width: 100%;
  gap: 2rem;
  padding: 0 2rem;
  transition: 150ms all;

  transform: translateX(${e=>e.$offsetX?e.$offsetX:0}px);
`,Pt=n.div`
  display: inline-flex;
  width: 100%;
  gap: 1rem;
  //padding: 0 0.5rem;
  transition: 150ms all;

  overflow-x: auto;
`,Tt=n.button`
  display: flex;
  flex-direction: column;
  gap: 0.225rem;

  align-items: center;
  justify-content: center;

  overflow: hidden;

  height: 64px;
  min-width: fit-content;

  background-color: #f7f7f7;

  transition: 150ms all;
  border-radius: 0.225rem;
  border: none;

  &.mobile {
    margin-right: 1rem;
  }

  cursor: pointer;

  &:hover {
    filter: brightness(0.98);
  }

  .title-and-icon {
    display: flex;
    gap: 0.225rem;
    align-items: baseline;
    justify-content: center;
    width: 100%;

    .title {
      width: fit-content;
      font-size: 12px;
      color: #6d6e71;
      white-space: nowrap;
    }

    .fire-icon {
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
    }
  }

  .icon-image {
    width: 18px;
    height: 18px;
    min-height: 18px;
    min-width: 18px;
    filter: brightness(0) saturate(100%) invert(46%) sepia(6%) saturate(201%)
      hue-rotate(188deg) brightness(89%) contrast(84%);
  }
`;var Ft="data:image/png;base64,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";const Ht=({canShow:i})=>{const{data:n,navigate:o,callTagManager:a}=_(),r=(null==n?void 0:n.getHeader.slider.sliderItems.find((e=>e.isFixed)))||null;return e(Bt,{className:i?"show":"",children:e(Dt,{children:t(Qt,{children:[r&&t(Tt,{className:"mobile",onClick:()=>{a("headerSimpleClick",r.title),o(r.redirect||"/")},children:[e("img",{className:"icon-image",src:r.icon,alt:"icon"}),t("span",{className:"title-and-icon",children:[e("span",{className:"title",children:r.title}),r.onFire&&e("img",{className:"fire-icon",src:Ft,alt:"icon"})]})]}),e(Pt,{children:null==n?void 0:n.getHeader.slider.sliderItems.filter((e=>!e.isFixed)).map((i=>t(Tt,{onClick:()=>{a("headerSimpleClick",i.title),o(i.redirect||"/")},children:[e("img",{className:"icon-image",src:i.icon,alt:"icon"}),t("span",{className:"title-and-icon",children:[e("span",{className:"title",children:i.title}),i.onFire&&e("img",{className:"fire-icon",src:Ft,alt:"icon"})]})]},i.id)))})]})})})},Gt=({canShow:i})=>{const{data:n,navigate:o,callTagManager:a}=_(),[d,s]=r(0),[g,h]=r(0),[p,m]=r(0),[u,f]=r((null==n?void 0:n.getHeader.slider.sliderItems.length)||0),x=c(null),b=c([]);l((()=>{const e=new ResizeObserver((()=>{(()=>{if(x.current){const e=x.current.offsetWidth;let t=0,i=0;for(const n of b.current)if(n){if(t+=n.offsetWidth+32,!(t<=e))break;i++}m(i)}})(),h(0),s(0)}));return x.current&&e.observe(x.current),()=>{x.current&&e.unobserve(x.current)}}),[]),l((()=>{n&&n.getHeader&&f(n.getHeader.slider.sliderItems.length)}),[n]);const w=e=>{var t;const i=(null===(t=x.current)||void 0===t?void 0:t.offsetWidth)||0,n=b.current.reduce(((e,t)=>e+((null==t?void 0:t.offsetWidth)||0)+32),0);if("NEXT"===e&&g+p<u){const e=b.current[g];if(e){const t=d-(e.offsetWidth+32);Math.abs(t)+i>=n?s(-(n-i)-28):s(t),h((e=>e+1))}}if("PREV"===e&&g>0){const e=b.current[g-1];if(e){const t=d+(e.offsetWidth+32);s(Math.min(t,0)),h((e=>e-1))}}};return e(Bt,{className:i?"show":"",children:e(Dt,{children:t(Qt,{children:[u>p&&e("div",{className:"control-buttons-container left",children:e("button",{className:"white-button",onClick:()=>w("PREV"),disabled:g<=0,children:e(Q,{color:"#0C881E"})})}),e(Ot,{$offsetX:d,ref:x,children:null==n?void 0:n.getHeader.slider.sliderItems.map(((i,n)=>t(Tt,{ref:e=>b.current[n]=e,onClick:()=>{a("headerSimpleClick",i.title),o(i.redirect||"/")},children:[e("img",{className:"icon-image",src:i.icon,alt:"icon"}),t("span",{className:"title-and-icon",children:[e("span",{className:"title",children:i.title}),i.onFire&&e("img",{className:"fire-icon",src:Ft,alt:"icon"})]})]},i.id)))}),u>p&&e("div",{className:"control-buttons-container right",children:e("button",{className:"white-button",onClick:()=>w("NEXT"),disabled:g+p>=u,children:e(M,{color:"#0C881E"})})})]})})})},zt=()=>{const{responsive:t}=G(),{canShowOnfireMenu:n}=_();return t.isSmall?e(Ht,{canShow:n}):t.isLarge||t.isMedium?e(Gt,{canShow:n}):e(i,{})},Yt=n.div`
  display: inline-flex;
  position: relative;
  align-items: center;
  width: 100%;
  gap: 2rem;

  .modal-padding {
    padding: 0;
  }
`,jt=n.button`
  display: inline-flex;
  gap: 0.5rem;
  align-items: center;
  cursor: pointer;

  font-weight: 400;
  font-size: 14px;

  transition: 200ms all;

  &:hover {
    color: #0c881e;
  }
`,Jt=n.div`
  display: grid;
  width: fit-content;
  grid-template-columns: auto auto;

  .category-title {
    display: inline-flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: space-between;
    width: fit-content;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    padding: 0.5rem;
    line-height: 140%;
    border: none;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .hovered {
    filter: brightness(1.1);
  }

  .category-item {
    display: flex;
    width: 100%;
    transition: 150ms all;
    font-weight: 400;
    font-size: 14px;
    color: #fff;
    background-color: #0c881e;
    cursor: pointer;

    &:hover {
      filter: brightness(1.1);
    }

    .category-content {
      display: flex;
      gap: 0.5rem;
      align-items: center;
      padding: 0.5rem 1rem;
    }
  }

  .green-column {
    display: flex;
    min-width: fit-content;
    flex-direction: column;
    background-color: #0c881e;
    padding-bottom: 0.5rem;
    border-radius: 0.5rem 0 0 0.5rem;
  }

  .white-column {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem 1rem 1rem 1.5rem;
    max-height: ${e=>e.$maxWhiteHeight};
    width: ${e=>e.$whiteWidth};
    min-width: 600px;
    transition:
      width 150ms ease-in-out,
      min-width 150ms ease-in-out; /* Smooth transition for width */
  }

  .button-area {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 100%;
    gap: 1rem;
  }

  .category-button {
    display: flex;
    width: 224px;
    color: #6d6e71;
    font-weight: 400;
    font-size: 14px;
    transition: 150ms all;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: #0c881e;
    }
  }

  .see-all-button {
    display: flex;
    width: 224px;
    color: #0c881e;
    font-weight: 600;
    font-size: 14px;
    transition: 150ms all;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;

    svg {
      fill: #0c881e;
    }

    &:hover {
      text-decoration: underline;
      color: #0c881e;
    }
  }
`,Zt=n.img`
  aspect-ratio: 267 / 344;
  border-radius: 0.5rem;
  object-fit: cover;
  transition: 150ms all;
  cursor: pointer;

  &:hover {
    filter: brightness(1.2);
  }
`,Ut=()=>{const{data:i,navigate:n,callTagManager:o}=_(),[a,c]=r(null);l((()=>{i&&c({name:i.getHeader.categoryMarketplace.children[0].name,children:i.getHeader.categoryMarketplace.children[0].children,bannerImage:i.getHeader.categoryMarketplace.children[0].bannerImage,redirect:i.getHeader.categoryMarketplace.children[0].redirect,url_path:i.getHeader.categoryMarketplace.children[0].url_path})}),[i]);const s=d((()=>{if(a){const e=10,t=224,i=(null==a?void 0:a.bannerImage)?267:0,n=32,o=Math.ceil(a.children.length/e),r=16*o;return Math.max(600,o*t+(r+n+i))+"px"}return"600px"}),[a]);return t(Jt,{$maxWhiteHeight:"376px",$whiteWidth:s(),children:[t("div",{className:"green-column",children:[t("button",{className:"category-title",onClick:()=>{o("headerSimpleClick",null==i?void 0:i.getHeader.categoryMarketplace.label),n("/loja")},children:[e(ke,{src:null==i?void 0:i.getHeader.categoryMarketplace.icon,color:"WHITE"}),null==i?void 0:i.getHeader.categoryMarketplace.label,e(O,{color:"#fff"})]}),null==i?void 0:i.getHeader.categoryMarketplace.children.map((i=>e("span",{className:"category-item"+(i.url_path===(null==a?void 0:a.url_path)?" hovered":""),onMouseEnter:()=>c({name:i.name,children:i.children,bannerImage:i.bannerImage,url_path:i.url_path,redirect:i.redirect}),onClick:()=>{o("headerSimpleClick",i.name),n(`/loja/${i.url_path}`||"/")},children:t("span",{className:"category-content",children:[e(ke,{src:i.icon,color:"WHITE"}),i.name]})},i.id)))]}),a&&t("div",{className:"white-column",children:[t("div",{className:"button-area",children:[null==a?void 0:a.children.map((t=>e("button",{className:"category-button",onClick:()=>{o("headerSimpleClick",t.name,a.name),n(`/loja/${t.url_path}`||"/")},children:t.name},t.id))),t("button",{className:"see-all-button",onClick:()=>{o("headerSimpleClick","ver-tudo",a.name),n(`/loja/${a.url_path}`||"/")},children:["Ver tudo ",e(L,{})]})]}),a.bannerImage&&e(Zt,{src:a.bannerImage,onClick:()=>n(a.redirect||"/")})]})]})},qt=()=>{const{data:n,navigate:o,callTagManager:a}=_(),{isOpen:r,onOpen:l,onClose:c,onIDChange:d,responsive:s}=G();return s.isSmall?e(i,{}):t(Yt,{children:[t(jt,{onClick:()=>{a("headerSimpleClick",null==n?void 0:n.getHeader.categoryMarketplace.label),d("MARKETPLACE_CATEGORIES"),l()},children:[e(ke,{src:null==n?void 0:n.getHeader.categoryMarketplace.icon}),null==n?void 0:n.getHeader.categoryMarketplace.label,e(y,{color:"#000"})]}),null==n?void 0:n.getHeader.menuLinks.filter((e=>!e.appOnly)).map((t=>e(jt,{onClick:()=>{a("headerSimpleClick",t.name),o(t.redirect||"/")},children:t.name},t.id))),e(ve,{id:"MARKETPLACE_CATEGORIES",className:"modal-padding",isOpen:r,onClose:c,position:{top:-8,left:-4},children:e(Ut,{})})]})},Wt=()=>e(ae,{children:t(Z,{children:[e(T,{children:t(F,{children:[e(Lt,{}),e(qt,{})]})}),e(zt,{})]})}),Xt=n.section`
  width: 100%;
  height: fit-content;
  background-color: #f7f7f7;
  border-top: 1px solid #008aeb;

  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
`,Kt=n.section`
  width: 100%;
  height: fit-content;
  background-color: #0c881e;

  display: flex;
  align-items: center;
  justify-content: center;

  span {
    white-space: nowrap;
  }
`,Vt=n.div`
  width: 100%;

  @media (min-width: 1312px) {
    width: 78rem;
  }
  @media (min-width: 1056px) and (max-width: 1311px) {
    width: 64rem;
  }
  @media (max-width: 1055px) {
    padding: 0 1rem;
  }
`,_t=u`
  query GetFooter {
    getFooter {
      link_loja_google
      link_loja_apple
      link_instagram
      link_facebook
      link_linkedin
      link_youtube
      link_qr_code
      createdAt
      updatedAt
      publishedAt
      aboutUs {
        id
        label
        menuLinks {
          id
          name
          redirect
          icon
          redirectMobile
          isWebview
          isExternalRedirect
        }
      }
      creditLine {
        id
        label
        menuLinks {
          id
          name
          redirect
          icon
          redirectMobile
          isWebview
          isExternalRedirect
        }
      }
      onlineStore {
        id
        label
        menuLinks {
          id
          name
          redirect
          icon
          redirectMobile
          isWebview
          isExternalRedirect
        }
      }
      forSellers {
        id
        label
        menuLinks {
          id
          name
          redirect
          icon
          redirectMobile
          isWebview
          isExternalRedirect
        }
      }
      forAdvisors {
        id
        label
        menuLinks {
          id
          name
          redirect
          icon
          redirectMobile
          isWebview
          isExternalRedirect
        }
      }
      downloadApp {
        id
        qrCodeImage
        title
        description
        label
        icon
        downloadAppButtons {
          id
          buttonName
          buttonIcon
          buttonLink
        }
      }
      socialMedia {
        id
        label
        SocialMediaIcons {
          id
          label
          url
        }
      }
      footerMetadata {
        id
        rights
        cnpj
        adress
        cep
      }
    }
  }
`,$t=o(void 0),ei=()=>{const e=a($t);if(!e)throw new Error("useFooterServiceContext should be used inside a FooterService provider");return e},ti=[{tagId:"footerSimpleClick",tagParams:{GTAGFunctionType:"INTERACT",event:ie.eventData,tela:"e-agro/footer",local_acao:"web",fluxo:"{{override}}",nome_elemento:"{{override}}"}}],ii=({children:t})=>{const{data:i,loading:n}=(()=>{const{loading:e,error:t,data:i}=x(_t);return{loading:e,error:t,data:i}})(),{callTagManager:o}=ne(ti),a=g();return e($t.Provider,{value:{data:i,loading:n,navigator:e=>a.push(e||"/"),callTagManager:o},children:t})},ni=n.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  padding: 2rem 0;
  gap: 1.5rem;
`,oi=n.img`
  width: 144px;
  height: 31px;
  min-height: 31px;
  min-width: 144px;
  cursor: pointer;

  @media (max-width: 1055px) {
    width: 146px;
    height: 32px;
    min-height: 32px;
    min-width: 146px;
  }
`,ai=n.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;

  .title {
    text-align: left;
    margin-bottom: 0%.5rem;
    font-size: 1rem;
    font-weight: 600;
    line-height: 140%;
    color: #000;
  }

  .advisor-seller-content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .internal-redirection-button {
    cursor: pointer;
    text-align: left;
    border: none;
    width: fit-content;
    color: #47484c;
    transition: 150ms all;

    font-size: 14px;
    font-weight: 400;
    line-height: 140%;

    &:hover {
      color: #008aeb;
      text-decoration: underline;
    }
  }

  @media (max-width: 1055px) {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .advisor-seller-content {
      justify-content: flex-end;
      flex-direction: row-reverse;
    }
  }
`,ri=n.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: fit-content;
  height: fit-content;
`;const li=({data:n})=>{var o;const{navigator:a,callTagManager:r}=ei();return n?t(ri,{children:[e("p",{className:"title",children:n.label||""}),null===(o=n.menuLinks)||void 0===o?void 0:o.map((t=>e("button",{className:"internal-redirection-button",onClick:()=>{r("footerSimpleClick",t.name,n.label),t.isExternalRedirect?window.open(t.redirect):a(t.redirect)},children:t.name},t.id)))]}):e(i,{})},ci=n.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .title {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    line-height: 140%;
    color: #6d6e71;
  }

  .mb-8 {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 1055px) {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;

    border-top: 1px solid #d9dcdd;
    padding-top: 1.5rem;
  }
`,di=n.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;

  .store-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .download-qr-area {
    width: 100%;
    display: inline-flex;
    gap: 0.5rem;
    align-items: center;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    background-color: #000;
    border-radius: 100px;
    color: #fff;
    padding: 0.5rem 1rem;
    transition: 200ms all;
    white-space: nowrap;
    cursor: pointer;

    font-weight: 500;
    font-size: 14px;

    &:hover {
      filter: brightness(0.8);
    }
  }

  .qr-code {
    width: 90px;
    height: 90px;
    min-height: 90px;
    min-width: 90px;
    border-radius: 0.225rem;
  }
`,si=n.div`
  display: flex;
  flex-direction: column;

  .social-container {
    display: inline-flex;
    gap: 1rem;
  }

  .social-button {
    width: fit-content;
    height: fit-content;
    transition: 150ms all;
    cursor: pointer;

    &:hover {
      filter: brightness(1.2);
    }

    &.facebook:hover {
      filter: brightness(0) saturate(100%) invert(33%) sepia(11%)
        saturate(2822%) hue-rotate(183deg) brightness(94%) contrast(88%);
    }

    &.instagram:hover {
      filter: brightness(0) saturate(100%) invert(31%) sepia(42%)
        saturate(6988%) hue-rotate(317deg) brightness(90%) contrast(91%);
    }

    &.linkedin:hover {
      filter: brightness(0) saturate(100%) invert(26%) sepia(69%)
        saturate(2369%) hue-rotate(179deg) brightness(96%) contrast(89%);
    }

    &.youtube:hover {
      filter: brightness(0) saturate(100%) invert(11%) sepia(96%)
        saturate(7389%) hue-rotate(7deg) brightness(113%) contrast(115%);
    }

    &.whatsapp:hover {
      filter: brightness(0) saturate(100%) invert(16%) sepia(92%)
        saturate(6041%) hue-rotate(145deg) brightness(104%) contrast(91%);
    }

    img {
      width: 32px;
      height: 32px;
      min-height: 32px;
      min-width: 32px;
    }
  }
`,gi=n.img`
  width: 16px;
  height: 16px;
  min-height: 16px;
  min-width: 16px;
  object-fit: contain;
`;function hi(e,t){return"instagram"===t?e.getFooter.link_instagram||"":"facebook"===t?e.getFooter.link_facebook||"":"linkedin"===t?e.getFooter.link_linkedin||"":"youtube"===t&&e.getFooter.link_youtube||""}const pi=()=>{const{data:i,callTagManager:n}=ei();return t(ci,{children:[t(di,{children:[e("p",{className:"title",children:null==i?void 0:i.getFooter.downloadApp.title}),t("div",{className:"download-qr-area",children:[e("div",{className:"store-container",children:null==i?void 0:i.getFooter.downloadApp.downloadAppButtons.map((o=>t("a",{href:o.buttonLink,target:"blank",rel:"noreferrer",onClick:()=>n("footerSimpleClick",o.buttonName,i.getFooter.downloadApp.title),children:[e(gi,{src:o.buttonIcon,alt:o.buttonName,loading:"lazy"}),o.buttonName]},o.id)))}),e("img",{src:null==i?void 0:i.getFooter.downloadApp.qrCodeImage,alt:"qr-code",loading:"lazy"})]})]}),t(si,{children:[e("p",{className:"title mb-8",children:null==i?void 0:i.getFooter.socialMedia.label}),e("div",{className:"social-container",children:null==i?void 0:i.getFooter.socialMedia.SocialMediaIcons.map((t=>e("a",{className:`social-button ${t.label}`,href:hi(i,t.label),target:"blank",rel:"noreferrer",onClick:()=>n("footerSimpleClick",t.label,i.getFooter.socialMedia.label),children:e("img",{src:t.url,alt:t.label,loading:"lazy"})},t.id)))})]})]})},mi=()=>{const{data:i,navigator:n}=ei();return t(ni,{children:[e(oi,{src:"data:image/png;base64,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",alt:"logo",loading:"lazy",onClick:()=>n("/")}),t(ai,{children:[(null==i?void 0:i.getFooter.aboutUs)&&e(li,{data:i.getFooter.aboutUs}),(null==i?void 0:i.getFooter.creditLine)&&e(li,{data:i.getFooter.creditLine}),(null==i?void 0:i.getFooter.onlineStore)&&e(li,{data:i.getFooter.onlineStore}),(null==i?void 0:i.getFooter.forAdvisors)&&i.getFooter.forSellers&&t("div",{className:"advisor-seller-content",children:[e(li,{data:i.getFooter.forAdvisors}),e(li,{data:i.getFooter.forSellers})]}),e(pi,{})]})]})},ui=n.div`
  display: inline-flex;
  width: 100%;
  height: fit-content;
  padding: 1.5rem;

  align-items: center;
  justify-content: center;

  @media (max-width: 1055px) {
    padding: 1rem;
  }
`,fi=n.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  width: fit-content;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;

  @media (max-width: 1055px) {
    width: 100%;
    flex-direction: column;
    gap: 0.5rem;
    span {
      white-space: normal;
      width: 100%;
    }
  }
`,xi=()=>{const{data:i}=ei();return e(ui,{children:t(fi,{children:[e("span",{children:(null==i?void 0:i.getFooter.footerMetadata.rights)||""}),e("span",{children:(null==i?void 0:i.getFooter.footerMetadata.cnpj)||""}),e("span",{children:(null==i?void 0:i.getFooter.footerMetadata.adress)||""}),e("span",{children:(null==i?void 0:i.getFooter.footerMetadata.cep)||""})]})})},bi=()=>window.isWebView?e(i,{}):t(ii,{children:[e(Xt,{children:e(Vt,{children:e(mi,{})})}),e(Kt,{children:e(Vt,{children:e(xi,{})})})]});export{bi as EagroFooter,Wt as EagroHeader};
//# sourceMappingURL=bundle.esm.js.map
